import { learningPathActionTypes } from '@/pages/learningPath/Constants';

import type { RewardTypes } from '@/components/stickers/types';
import type { Step } from '@/pages/learningPath/types';

export function getLearningPathRequest() {
	return {
		type: learningPathActionTypes.GET_LEARNING_PATH_REQUEST,
	};
}

export function getLearningPathSuccess(data: any) {
	return {
		type: learningPathActionTypes.GET_LEARNING_PATH_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getLearningPathError() {
	return {
		type: learningPathActionTypes.GET_LEARNING_PATH_ERROR,
	};
}

export function updateLearningPath(steps: Step[]) {
	return {
		type: learningPathActionTypes.UPDATE_LEARNING_PATH,
		payload: {
			steps,
		},
	};
}

export function updateOnboardingDataRequest(key: string, status?: string) {
	return {
		type: learningPathActionTypes.UPDATE_ONBOARDING_DATA_REQUEST,
		payload: {
			key,
			status,
		},
	};
}

export function updateTileProgressStatus(stepId: string, isCorrect: boolean) {
	return {
		type: learningPathActionTypes.UPDATE_TILE_PROGRESS_STATUS,
		payload: {
			stepId,
			isCorrect,
		},
	};
}

export function finishTileProgress(stepId: string) {
	return {
		type: learningPathActionTypes.FINISH_TILE_PROGRESS,
		payload: {
			stepId,
		},
	};
}

export function setLearningPathUpdated(isUpdated: boolean) {
	return {
		type: learningPathActionTypes.SET_LEARNING_PATH_UPDATED,
		payload: {
			isUpdated,
		},
	};
}

export function setFinishTileAnimation(finishTileAnimation: boolean) {
	return {
		type: learningPathActionTypes.SET_FINISH_TILE_ANIMATION,
		payload: {
			finishTileAnimation,
		},
	};
}

export function setTileSelectionMode(tileSelectionMode: string | false) {
	return {
		type: learningPathActionTypes.SET_TILE_SELECTION_MODE,
		payload: {
			tileSelectionMode,
		},
	};
}

export function setShorterLearningPathAnimation(shorterLearningPathAnimation: boolean) {
	return {
		type: learningPathActionTypes.SET_SHORTER_LEARNING_PATH_ANIMATION,
		payload: {
			shorterLearningPathAnimation,
		},
	};
}

export function setSkipTileAnimation(skipTileAnimation: boolean) {
	return {
		type: learningPathActionTypes.SET_SKIP_TILE_ANIMATION,
		payload: {
			skipTileAnimation,
		},
	};
}

export function setRewardUserSheetId(rewardUserSheetId: number | null) {
	return {
		type: learningPathActionTypes.SET_REWARD_USER_SHEET_ID,
		payload: {
			rewardUserSheetId,
		},
	};
}

export function setSelectedTile(selectedTile: Step | null) {
	return {
		type: learningPathActionTypes.SET_SELECTED_TILE,
		payload: {
			selectedTile,
		},
	};
}

export function setCurrentSteps(steps: Step[]) {
	return {
		type: learningPathActionTypes.SET_CURRENT_STEPS,
		payload: {
			steps,
		},
	};
}

export function setNewSteps(newSteps: Step[]) {
	return {
		type: learningPathActionTypes.SET_NEW_STEPS,
		payload: {
			newSteps,
		},
	};
}

export function setTilesToReplace(tilesToReplace: Step[]) {
	return {
		type: learningPathActionTypes.SET_TILES_TO_REPLACE,
		payload: {
			tilesToReplace,
		},
	};
}

export function sendCollectedRewardRequest(id: number, body: any, rewardType: string) {
	return {
		type: learningPathActionTypes.SEND_COLLECTED_REWARD_REQUEST,
		payload: {
			id,
			body,
			rewardType,
		},
	};
}

export function setPreviewMode(previewMode: boolean) {
	return {
		type: learningPathActionTypes.SET_PREVIEW_MODE,
		payload: {
			previewMode,
		},
	};
}

export function clearLearningPath() {
	return {
		type: learningPathActionTypes.CLEAR_LEARNING_PATH,
	};
}

export function receivedLearningPathChannelStream(data: any) {
	return {
		type: learningPathActionTypes.RECEIVED_LEARNING_PATH_CHANNEL_STREAM,
		payload: {
			data,
		},
	};
}

export function receivedLearningPathChannelStreamSuccess(data: any) {
	return {
		type: learningPathActionTypes.RECEIVED_LEARNING_PATH_CHANNEL_STREAM_SUCCESS,
		payload: {
			data,
		},
	};
}

export function setAutonomyMode(autonomyMode: boolean) {
	return {
		type: learningPathActionTypes.SET_AUTONOMY_MODE,
		payload: {
			autonomyMode,
		},
	};
}

export function setTypeformSurvey(surveyCode: string) {
	return {
		type: learningPathActionTypes.SET_TYPEFORM_SURVEY,
		payload: {
			surveyCode,
		},
	};
}

export function getAutonomyExperimentRequest() {
	return {
		type: learningPathActionTypes.GET_AUTONOMY_EXPERIMENT_REQUEST,
	};
}

export function getAutonomyExperimentSuccess() {
	return {
		type: learningPathActionTypes.GET_AUTONOMY_EXPERIMENT_SUCCESS,
	};
}

export function getAutonomyExperimentError() {
	return {
		type: learningPathActionTypes.GET_AUTONOMY_EXPERIMENT_ERROR,
	};
}
